import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../lib/api';

export function SavHistory({ id }) {
    const [h, setH] = useState(null);
    useEffect(() => { axios.get(`${API_URL}/api/sav/${id}/historique`, { withCredentials: true }).then(r => setH(r.data)).catch(() => setH([])); }, [id]);
    if (!h) return null;
    return (
        <div className="pt-2 border-t border-gray-100" data-testid="sav-history">
            <p className="text-[11px] uppercase tracking-wider text-gray-400 mb-1">Historique</p>
            {!h.length && <p className="text-[12px] text-gray-400">Aucune modification enregistrée</p>}
            <ul className="space-y-1 max-h-48 overflow-auto">
                {h.map((e, i) => (
                    <li key={i} className="text-[11px] text-gray-600" data-testid={`sav-history-${i}`}>
                        <span className="text-gray-400">{new Date(e.timestamp).toLocaleString('fr-FR')} · {e.user_name}</span> — {e.comment || e.action}
                        {(e.changes || []).map((c, j) => <span key={j} className="block pl-3 text-gray-500">{c.field} : {String(c.old ?? c.old_value ?? '—') || '—'} → {String(c.new ?? c.new_value ?? '—') || '—'}</span>)}
                    </li>
                ))}
            </ul>
        </div>
    );
}
